import { sides, xyz } from '@/Interfaces/common';
import { Vector3 } from 'three';
import { Room } from '@/Engine/Room';

export const transformPositionBySide = (position: Vector3, side: sides, room: Room): xyz  => {
    let newPosition: xyz;

    switch (side) {
        case 'front':
            newPosition = [
                position.x,
                position.y,
                0.015, //TODO откуда взялось?
            ];
            break;
        case 'left':
            newPosition = [
                room.leftWallWidth-position.z,
                position.y,
                0,
            ];
            break;
        case 'right':
            newPosition = [
                position.z,
                position.y,
                0,
            ];
            break;
        case 'back': {
            const right = room.rightWallWidth > room.leftWallWidth;
            const back = room.backWallWidth < room.frontWallWidth;
            if (right && back) {
                newPosition = [
                    room.width - position.x,
                    position.y,
                    0.015, //TODO откуда взялось?
                ];
            }
            else {
                newPosition = [
                    room.backWallWidth - position.x,
                    position.y,
                    0.015, //TODO откуда взялось?
                ];
            }
        }

    }
    return newPosition;

};